import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  headerBoxContainer: {
    marginTop: '1.25rem',
    marginBottom: '6rem',
  },

  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },

  itemHead: {
    margin: '0.75rem 0',
  },

  itemList: {
    marginTop: '-1.25rem !important',
  },
}))

export { useStyles }
